import { FC, useMemo } from 'react';
import { Image } from 'react-bootstrap';
import styled from 'styled-components';

import Typography from 'app/components/Typography';

import { getInitialsCharacter } from 'app/helpers/utils';

import { OrganizationInfo, useOrganizationStore } from './aside/store';

const MenuSwitchOrgWrapper = styled.div`
  display: flex;
  width: 280px;
  min-height: max-content;
  max-height: 600px;
  border-radius: 8px;
  background: #ffffff;
  flex-direction: column;
`;

const OrganizationItem = styled.div`
  padding: 8px 6px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    p {
      color: var(--primary);
    }
    background: var(--primary-2);
  }
`;

interface Props {
  handleSelectOrg: (id: number, name: string, logo: string) => void;
  organizations: OrganizationInfo[] | undefined;
}

const MenuSwitchOrg: FC<Props> = ({ handleSelectOrg, organizations }) => {
  const organization = useOrganizationStore.getState().state.organization;
  const organizationsNotActive = organizations?.filter((org) => org.id !== organization?.id);

  function getColorFromName(name: string) {
    const colors = [
      'var(--primary)',
      'var(--success-3)',
      'var(--warning)',
      'var(--info)',
      'var(--teal)',
      'var(--pink)',
    ];

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    return colors[Math.abs(hash) % colors.length];
  }

  return (
    <MenuSwitchOrgWrapper>
      <Typography
        variant="body-8"
        color="neutral-6"
        style={{ marginBottom: '2px', marginLeft: 20 }}
      >
        Organization
      </Typography>
      {organizationsNotActive?.map((org) => (
        <OrganizationItem
          key={org.id}
          onClick={() => handleSelectOrg(org.id, org.name, org.logo || '')}
        >
          <div className="d-flex align-items-center" style={{ gap: 10, padding: 3 }}>
            <div
              style={{
                backgroundColor: org.logo ? 'transparent' : getColorFromName(org.name || 'Unknown'),
                width: 30,
                height: 30,
                borderRadius: 6,
                flexShrink: 0,
                // overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                variant="title-5"
                className="text-white d-flex justify-content-center align-items-center"
                lineHeight={30}
              >
                {org.logo ? (
                  <Image
                    src={org.logo}
                    alt={org.name || 'Organization logo'}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      borderRadius: 8,
                      margin: 0,
                    }}
                  />
                ) : (
                  getInitialsCharacter(org.name || '')
                )}
              </Typography>
            </div>
            <Typography variant="body-3" color="neutral-10" className="limit-text">
              {org.name}
            </Typography>
          </div>
        </OrganizationItem>
      ))}
    </MenuSwitchOrgWrapper>
  );
};

export default MenuSwitchOrg;
